/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `prospect` - Prospect
* `trial` - Trial
* `active` - Active
* `inactive` - Inactive
* `churned` - Churned
 */
export type OrganizationStatusEnum = typeof OrganizationStatusEnum[keyof typeof OrganizationStatusEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationStatusEnum = {
  prospect: 'prospect',
  trial: 'trial',
  active: 'active',
  inactive: 'inactive',
  churned: 'churned',
} as const;
